import api from './api';

const productService = {
  // Public endpoints
  getProducts: (params = {}) => {
    return api.get('/products/', { params });
  },

  getProductById: (id) => {
    return api.get(`/products/${id}/`);
  },

  getCategories: () => {
    return api.get('/products/categories/');
  },

  getCategoryById: (id) => {
    return api.get(`/products/categories/${id}/`);
  },

  getCities: () => {
    return api.get('/products/cities/');
  },

  // Partner endpoints (require authentication)
  partnerMatchProduct: (data) => {
    return api.post('/products/partner/match/', data);
  },

  partnerCreateVariant: (productId, data) => {
    return api.post(`/products/partner/products/${productId}/variants/`, data);
  },

  partnerGetInventory: (params = {}) => {
    return api.get('/products/partner/inventory/', { params });
  },

  partnerCreateInventory: (data) => {
    return api.post('/products/partner/inventory/', data);
  },

  partnerUpdateInventory: (id, data) => {
    return api.patch(`/products/partner/inventory/${id}/`, data);
  },

  partnerDeleteInventory: (id) => {
    return api.delete(`/products/partner/inventory/${id}/`);
  },

  // Admin endpoints (require admin authentication)
  adminGetProducts: (params = {}) => {
    return api.get('/products/admin/products/', { params });
  },

  adminEnrichProduct: (id, data) => {
    return api.patch(`/products/admin/products/${id}/enrich/`, data);
  },

  adminCreateCategory: (data) => {
    return api.post('/products/admin/categories/', data);
  },

  adminUpdateCategory: (id, data) => {
    return api.patch(`/products/admin/categories/${id}/`, data);
  },

  adminDeleteCategory: (id) => {
    return api.delete(`/products/admin/categories/${id}/`);
  },
};

export default productService;
